import { taskPollingService } from './taskPollingService';
import { analysisService } from './analysisService';
import { brandbookService } from './brandbookService';
import { generationService } from './generationService';
import { galleryService } from './galleryService';
import { uploadService } from './uploadService';
import { workflowAssistantService } from './workflowAssistantService';
import { ensureCampaign, ensureHomeDecorCampaign } from './campaignHelpers';

// Re-export types
export type { AnalysisResult, GenerationResponse, TaskResponse } from './types';
export type { WorkflowAssistantResponse, WorkflowAssistantTurn } from './workflowAssistantService';

// Re-export domain services for direct imports
export { taskPollingService } from './taskPollingService';
export { analysisService } from './analysisService';
export { brandbookService } from './brandbookService';
export { generationService } from './generationService';
export { galleryService } from './galleryService';
export { uploadService } from './uploadService';
export { workflowAssistantService } from './workflowAssistantService';
export { ensureCampaign, ensureHomeDecorCampaign } from './campaignHelpers';

export const aiService = {
    // Analysis
    ...analysisService,
    // Brandbook
    ...brandbookService,
    // Generation
    ...generationService,
    // Gallery
    ...galleryService,
    // Upload
    ...uploadService,
    // Workflow Assistant (Agente IA)
    ...workflowAssistantService,
    // Polling
    ...taskPollingService,
    // Helpers
    ensureCampaign,
    ensureHomeDecorCampaign,
};

export default aiService;
